import React from 'react';
import clsx from 'clsx';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '@contexts/AuthContext';
import styles from './PageLayout.module.css';

interface PageLayoutProps {
  children: React.ReactNode;
  title?: string;
  showSearch?: boolean;
  searchPlaceholder?: string;
  onSearch?: (searchTerm: string) => void;
  headerActions?: React.ReactNode;
  className?: string;
  showHeader?: boolean;
}

const PageLayout = React.memo(function PageLayout({
  children,
  title,
  showSearch = false,
  searchPlaceholder,
  onSearch,
  headerActions,
  className = '',
  showHeader = false
}: PageLayoutProps) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className={clsx('app-container', className)}>
      <Sidebar />

      <main className={styles.mainContent}>
        {showHeader && (
          <div className={styles.headerWrapper}>
            <Header
              title={title}
              showSearch={showSearch}
              searchPlaceholder={searchPlaceholder}
              onSearch={onSearch}
              actions={headerActions}
            />
          </div>
        )}

        <div className={styles.pageContent}>{children}</div>
      </main>
    </div>
  );
});

export default PageLayout;
